import lodash from 'lodash';

export const gatherBinderStudiesTableData = (bindersAndStudies) => {
    const formattedDate = (databaseDate) => {
        if (databaseDate && typeof databaseDate === 'string') {
            const dateObject = new Date(databaseDate);
            if (!isNaN(dateObject.getTime())) {
                return lodash.template('<%= date %> <%= time %>')({
                    date: lodash.join([dateObject.getDate(), dateObject.toLocaleString('en-US', { month: 'short' }).replace(/^(\w{1})/, match => match.toUpperCase()), dateObject.getFullYear()], ' '),
                    time: dateObject.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit' }),
                });
            }
        }
        return '--';
    };

    return lodash.map(bindersAndStudies, (binder) => {
        const isBinder = lodash.get(binder, ['isStudy']) === null;
        let showUnfiledDocuments, showPendingTasks;
        if (isBinder) {
            showUnfiledDocuments = true;
            showPendingTasks = true;
        }
        else {
            if (binder.binderId) { // Normal study
                showUnfiledDocuments = true;
                showPendingTasks = true;
            }
            else {
                showUnfiledDocuments = false; // Draft study
                showPendingTasks = true;
            }

        }
        return {
            id: lodash.get(binder, ['id']),
            sub: lodash.get(binder, ['id']),
            binderId: lodash.get(binder, ['binderId']),
            name: lodash.get(binder, ['name']),
            sponsor: lodash.get(binder, ['sponsorCro']) || '--',
            cro: lodash.get(binder, ['cro']) || '--',
            protocol: lodash.get(binder, ['trialId']) || '--',
            binderType: lodash.get(binder, ['studyTypeName']) || '--',
            unfiledDocuments: showUnfiledDocuments ? lodash.get(binder, ['unfiledDocumentsCount']) || '0' : 'N/A',
            pendingTasks: showPendingTasks ? lodash.get(binder, ['pendingTasksCount']) || '0' : 'N/A',
            activationDate: lodash.get(binder, ['activationDate']) ? formattedDate(lodash.get(binder, ['activationDate'])) : '--',
            studyStage: lodash.get(binder, ['currentStageName']) || (!isBinder && 'Lifecycle Unassigned') || '--',
            template: lodash.get(binder, ['binderTemplate', 'displayName']) || '--',
            renewalDate: lodash.get(binder, ['renewalDate']) ? formattedDate(lodash.get(binder, ['renewalDate'])) : '--',
            irbNumber: lodash.get(binder, ['irbNumber']) || '--',
            ctGovNumber: lodash.get(binder, ['ctGovNumber']) || '--',
            contact: lodash.get(binder, ['contact']) || '--',
            createdAt: lodash.get(binder, ['createdAt']) ? formattedDate(lodash.get(binder, ['createdAt'])) : '--',
            status: lodash.get(binder, ['status']) || '--',
            primaryInvestigator: lodash.get(binder, ['primaryInvestigator']) || '--',
            site: lodash.get(binder, ['site']) || '--',
            department: lodash.get(binder, ['department']) || '--',
            diseaseGroup: lodash.get(binder, ['diseaseGroup']) || '--',
            siteNumber: lodash.get(binder, ['departmentSiteDg']) || '--',
            institutionId: lodash.get(binder, ['institutionId']) || '',
            studyType: lodash.get(binder, ['studyTypeName']) || '--',
            category: lodash.get(binder, ['category']) || null,
            isBinder: lodash.get(binder, ['isStudy']) === null
        };
    });

};